import { css } from '@emotion/react'
import ClockIconDark from 'assets/images/landing/single-clock-dark.svg?component'
import ClockIcon from 'assets/images/landing/single-clock-light.svg?component'
import { Theme, useTheme } from 'contexts/theme-context'
import { Trans, useTranslation } from 'react-i18next'
import tw from 'twin.macro'

import { Step } from './steps-swiper'

const borderStyles = css`
  & {
    content: '';
    position: absolute;
    inset: 0;
    padding: 2px;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
    border-radius: 15px;
  }
  &:hover {
    opacity: 1;
  }
`

const boxStyles = css`
  & {
    width: 100%;
    --border-radius: 12px;
    --border-size: 1px;
    --padding: 1px;
    --border-bg: conic-gradient(
      from 180deg at 50% 50%,
      rgba(255, 255, 255, 0.8) 0deg,
      rgba(255, 255, 255, 0.6) 112.5deg,
      rgba(255, 255, 255, 0.4) 228.75deg,
      rgba(255, 255, 255, 0.1) 360deg
    );
    --border-bg-light: conic-gradient(
      from 180deg at 50% 50%,
      rgba(162, 162, 173, 1) 0deg,
      rgba(58, 58, 60, 0) 112.5deg,
      rgba(255, 255, 255, 0) 228.75deg,
      rgba(255, 255, 255, 0.44) 360deg
    );
    position: relative;
    overflow: hidden;
    font-size: 2rem;
    border-radius: 15px;

    z-index: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    perspective: 1000;
    transform: translateZ(0);
    transfom: translateZ(0);
  }
`

const getBeforeStyles = (theme: Theme) => css`
  &::before {
    content: '';
    display: block;
    width: calc(100% * 1.41421356237);
    padding-bottom: calc(100% * 1.41421356237);
    position: absolute;
    background: var(${theme === 'dark' ? '--border-bg' : '--border-bg-light'});
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 100%;
    z-index: -2;
    animation: spin 5s linear infinite;
  }
  @keyframes spin {
    0% {
      transform: translate(-50%, -50%) rotate(-1turn);
    }

    to {
      transform: translate(-50%, -50%) rotate(0);
    }
  }
`

const StepItem = ({ step, isActive, stepsCount }: { step: Step; isActive: boolean; stepsCount: number }) => {
  const { t } = useTranslation('landing')
  const { theme, isDarkTheme } = useTheme()

  return (
    <div
      className='cursor-grab active:cursor-grabbing'
      css={[tw`transition-opacity duration-300 `, !isActive && tw`opacity-90 blur-sm`]}
    >
      <p
        css={[
          tw`text-sm font-semibold leading-4 text-[var(--text-title)] md:text-2xl md:leading-7`,
          stepsCount >= step.step ? tw`visible` : tw`invisible`
        ]}
      >
        <Trans
          components={{
            span: <span tw='opacity-50' />
          }}
          values={{
            currentStep: step.step,
            totalSteps: stepsCount
          }}
        >
          {t('steps-section.step-text')}
        </Trans>
      </p>
      <div
        css={[
          tw`flex flex-col sm:justify-between h-[270px] rounded-2xl mt-4
           backdrop-blur-[15px] bg-[var(--color-bg-swiper-card)] py-5 px-6 relative`,
          boxStyles
        ]}
      >
        <div css={[borderStyles, getBeforeStyles(theme)]} />

        <div className='mb-3'>
          <h2 className='text-[var(--text-title)] text-lg sm:text-[28px] sm:leading-[140%]  font-bold mb-[10.32px]'>
            {t(step.title)}
          </h2>
          <p className='lg:w-3/4 text-[var(--text-step-card-body)]  text-base'>{t(step.bodyText)}</p>
        </div>
        <div className='flex items-center gap-3'>
          {isDarkTheme ? <ClockIconDark /> : <ClockIcon />}
          <p className='text-[var(--text-step-card-footer)] text-[14px] sm:text-[18px] leading-[140%]'>
            {t(step.footerText)}
          </p>
        </div>
        <img src={step.icon} alt='CARD_ICON' className='absolute bottom-5 right-5' />
      </div>
      <p></p>
    </div>
  )
}

export default StepItem
